export default __webpack_public_path__ + "static/media/osc_icon.57398a31.png";